import { render } from "./VUEDataTable.vue?vue&type=template&id=1ca3de0d"
import script from "./VUEDataTable.vue?vue&type=script&lang=js"
export * from "./VUEDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__